var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQubitArrangement = function SvgQubitArrangement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 356,
    viewBox: "33 -61 487 356",
    width: 487,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.5102,
    cy: 55.97959,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(49 42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "DR"), /*#__PURE__*/React.createElement("tspan", {
    y: 21
  }, "Q1")), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 55.97959,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(263 42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q3")), /*#__PURE__*/React.createElement("circle", {
    cx: 478.4694,
    cy: 55.959184,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(465.5 42)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q5")), /*#__PURE__*/React.createElement("circle", {
    cx: 478.4694,
    cy: 253.9796,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 253.9796,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(163 143)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q2")), /*#__PURE__*/React.createElement("circle", {
    cx: 74.5102,
    cy: 253.9796,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(365 143)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q4")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(264 240)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q7")), /*#__PURE__*/React.createElement("circle", {
    cx: 175.9796,
    cy: 156.9796,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(62 240)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q6")), /*#__PURE__*/React.createElement("circle", {
    cx: 377.9796,
    cy: 156.9796,
    r: 39.979656
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(465 240)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21
  }, "Q8")), /*#__PURE__*/React.createElement("path", {
    d: "m103.55422 84.88925 43.38135 43.18068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.46838 185.43563 41.54284 40.08793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.35607 185.29545-42.23255 40.36829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.98494 225.51907-41.5209-40.07896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.8801 127.92647 42.68877-42.91417"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.93412 128.07139-43.38865-43.1836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.88747 127.9338 42.70466-42.90841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.1323 225.66225 42.2252-40.36532"
  }))));
};
export default SvgQubitArrangement;